import { type ComponentType } from 'react';

import { Dollar } from '@depop/web-thrift-ui/Icons/Dollar';
import { EditListing } from '@depop/web-thrift-ui/Icons/EditListing';
import { Link } from '@depop/web-thrift-ui/Icons/Link';
import { LockOutline } from '@depop/web-thrift-ui/Icons/LockOutline';
import { Payout } from '@depop/web-thrift-ui/Icons/Payout';
import { Receipt } from '@depop/web-thrift-ui/Icons/Receipt';
import { Review } from '@depop/web-thrift-ui/Icons/Review';
import { Suggestion } from '@depop/web-thrift-ui/Icons/Suggestion';
import { Support } from '@depop/web-thrift-ui/Icons/Support';
import { VerificationOutline } from '@depop/web-thrift-ui/Icons/VerificationOutline';
import {
  type DefaultSizes,
  type SharedIconProps,
} from '@depop/web-thrift-ui/Icons/types';

type IconListItem = {
  icon: ComponentType<{ size: DefaultSizes } & SharedIconProps>;
  titleKey: string;
  descriptionKey: string;
};

export const BENEFITS: IconListItem[] = [
  {
    icon: VerificationOutline,
    titleKey: 'Benefits.VerifiedBadge.Title',
    descriptionKey: 'Benefits.VerifiedBadge.Description',
  },
  {
    icon: Payout,
    titleKey: 'Benefits.FasterPayouts.Title',
    descriptionKey: 'Benefits.FasterPayouts.Description',
  },
  {
    icon: Suggestion,
    titleKey: 'Benefits.MoreVisibility.Title',
    descriptionKey: 'Benefits.MoreVisibility.Description',
  },
  {
    icon: Support,
    titleKey: 'Benefits.PrioritySupport.Title',
    descriptionKey: 'Benefits.PrioritySupport.Description',
  },
  {
    icon: Link,
    titleKey: 'Benefits.ForumAccess.Title',
    descriptionKey: 'Benefits.ForumAccess.Description',
  },
];

export const ELIGIBILITY_CRITERIA: IconListItem[] = [
  {
    icon: Dollar,
    titleKey: 'Eligibility.Sales.Title',
    descriptionKey: 'Eligibility.Sales.Description',
  },
  {
    icon: Review,
    titleKey: 'Eligibility.Reviews.Title',
    descriptionKey: 'Eligibility.Reviews.Description',
  },
  {
    icon: Receipt,
    titleKey: 'Eligibility.OrderIssues.Title',
    descriptionKey: 'Eligibility.OrderIssues.Description',
  },
  {
    icon: EditListing,
    titleKey: 'Eligibility.Listings.Title',
    descriptionKey: 'Eligibility.Listings.Description',
  },
  {
    icon: LockOutline,
    titleKey: 'Eligibility.Terms.Title',
    descriptionKey: 'Eligibility.Terms.Description',
  },
];

export const TESTIMONIAL_SELLER_IDS = {
  shoplovelacy: '18662390',
  mercene: '5394169',
  sick_angelz: '22575508',
} as const;
